import { Data } from "../models/data";
import { Util } from "../utils/util";
import { HttpService } from "./http-service";
import { IService } from "./service.interface";

export class GeolocationService implements IService {
    private readonly _http: HttpService;
    private readonly _data: Data;
    private readonly _apiGeolocationLookup: string;

    constructor(http: HttpService, data: Data, apiGeolocationLookup: string) {
        this._http = http;
        this._data = data;
        this._apiGeolocationLookup = apiGeolocationLookup;
    }

    public httpRequestAsync(method: string, url: string, payload: object | null = null, options?: { showProgress?: boolean, noCache?: boolean }): Promise<Response> {
        const storeKey = this._data.getProperty("StoreInfo")?.storeKey
            ?? this._data.getBrandProperty("StoreInfo").storeKey;

        const timeOffset = this._data.getProperty("TimeOffset")
            ?? this._data.getBrandProperty("TimeOffset");

        const businessStartMinute = this._data.getProperty("Settings")?.BSM
            ?? this._data.getBrandProperty("Settings").BSM;

        let businessDate = new Date().toISOString();
        try {
            businessDate = Util.GetBUSDate(Util.NowStore(timeOffset), timeOffset, businessStartMinute).toISOString();
        } catch { }

        return this._http.request(method, url, payload, storeKey, businessDate, { showProgress: options?.showProgress, noCache: options?.noCache });
    }

    /**
     * Validates a zip code using an external API
     * @async
     * @param {string} zip - The zip code to validate
     * @returns {Promise<boolean>} - Indicates if the zip code is valid
     */
    public async validateZip(zipCode: string): Promise<boolean> {
        const response = await this.httpRequestAsync('GET', `${this._apiGeolocationLookup}validate_zip?zip=${zipCode}`, null, { showProgress: false, noCache: false });
        const json = response.status === 200 ? await this._http.getJson(response) : null;
        return json ?? false;
    }
}